import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Topbar from './components/Topbar'; 
import Footer from './components/Footer';
import './App.css';
import './assets/css/style.css'; 
import './assets/css/common.css'; 
import ProductDetail from './pages/ProductDetail';
import BecomeSeller from './pages/BecomeSeller';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Profile from './pages/Profile';
import Orders from './pages/Orders';
import Shop from './pages/Shop';
import Category from './pages/Category';
import ShippingAddress from './components/ShippingAddress';
 

import ScrollToTop from './ScrollToTop';
import AllCategory from './pages/component/AllCategory';
import Faqs from './pages/Static/Faqs';
import Contact from './pages/Static/Contact';
import MyWishlist from './pages/MyWishlist';
import Invoice from './pages/Invoice';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Return from './pages/Return';
import Shipping from './pages/Shipping';
import { CartProvider } from './context/CartContext';
import Coupons from './pages/Coupons';

function App() {
  return (
    
      <Router>

<CartProvider>

        <ScrollToTop />

        <Topbar />
        <Routes>  
          <Route path="/" element={<Home />} /> 
          <Route path="/product/:slug" element={<ProductDetail />} /> 
          <Route path="/seller" element={<BecomeSeller />} /> 
          <Route path="/cart" element={<Cart />} /> 
          <Route path="/checkout" element={<Checkout />} /> 
          <Route path="/profile" element={<Profile />} /> 
          <Route path="/orders" element={<Orders />} /> 
          <Route path="/shop/:category/:subcategory" element={<Shop />} /> 
          <Route path="/category/:category" element={<Category />} /> 
          <Route path="/ship-address" element={<ShippingAddress />} /> 
          <Route path="/all-categories" element={<AllCategory />} /> 
          <Route path="/faq" element={<Faqs />} /> 
          <Route path="/contact" element={<Contact />} /> 
          <Route path="/wishlist" element={<MyWishlist />} /> 
          <Route path="/invoice/:order_uuid" element={<Invoice />} /> 
          <Route path="/forgot-password" element={<ForgotPassword />} /> 
          <Route path="/reset-password/:token" element={<ResetPassword />} /> 
            
          <Route path="/privacy" element={<Privacy />} /> 
          <Route path="/terms" element={<Terms />} /> 
          <Route path="/returns" element={<Return />} /> 
          <Route path="/shipping" element={<Shipping />} /> 
          <Route path="/coupons" element={<Coupons />} /> 
 
        </Routes>
        <Footer />

        </CartProvider>
        
      </Router> 
  );
}

export default App;
